const { h, render, Component } = require('preact');
const GuestHelp = require('../../views/guest/guest_help');
const Web2018Helper = require('../../../helper');

class ArticleContent extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
    this.showGuestHelpOptions = this.showGuestHelpOptions.bind(this);
  }

  handleClick() {
    this.props.handleNeedHelpFromSearchResults(this.props.article)
  }

  showGuestHelpOptions() {
    return Web2018Helper.showGuestHelpOptions(this.props.article) 
      && this.props.showGuestHelp // The user has not already checked the FAQ (in which case show the contact channel link will be shown).
  }

  render() {
    return (
      <div class="article-contents">
        <div class='title'>{this.props.article.title}</div>
        <div dangerouslySetInnerHTML={{ __html: this.props.article.answer }} />
        {
          this.showGuestHelpOptions() ?
            (<GuestHelp article={this.props.article} onClickHelp={this.props.onGuestHelp} />) :
            (
              <p class="contact-us-section">
                {I18n.translate("js.modules.web_2018.still_need_help")}&nbsp;
          <span class="contact-us-link" data-bhw="web2018_faq_article_contact-us-link" onclick={this.handleClick}>{I18n.translate("js.modules.support.contactus")}</span>
              </p>
            )
        }
      </div>
    )
  }
}

module.exports = ArticleContent
